import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {NgxSuneditorModule} from "ngx-suneditor";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule, Routes} from "@angular/router";
import {HomeComponent} from './pages/home/home.component';
import {NotFoundPageComponent} from './not-found-page/not-found-page.component';
import {NewPageComponent} from './dashbord/new-page/new-page.component';
import {ButtonModule} from "primeng/button";
import {InputTextModule} from "primeng/inputtext";
import {TabViewModule} from "primeng/tabview";
import {FormsModule} from "@angular/forms";
import {DialogModule} from "primeng/dialog";
import {SafeHtmlPipe} from './service/safe-html.pipe';
import {ColorPickerModule} from "primeng/colorpicker";
import {LoginComponent} from './dashbord/login/login.component';
import {TemplateComponent} from './dashbord/template/template.component';
import {DocsComponent} from './docs/docs.component';
import {RestBackendService} from "./service/rest-backend.service";
import {ConfirmationService, MessageService} from "primeng/api";
import {GlobalService} from "./service/global.service";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {ToastModule} from "primeng/toast";
import {ProgressBarModule} from "primeng/progressbar";
import {PasswordModule} from "primeng/password";
import {AdminDocsComponent} from './dashbord/admin-docs/admin-docs.component';
import {JalaliDateCalculatorService, NgxPersianModule, PersianNumberService} from "ngx-persian";
import {HttpClientModule} from "@angular/common/http";
import {SlideMenuModule} from "primeng/slidemenu";
import {AutoCompleteModule} from "primeng/autocomplete";
import {TreeModule} from "primeng/tree";
import {ContextMenuModule} from "primeng/contextmenu";
import {InputTextareaModule} from "primeng/inputtextarea";
import {ConfigService} from "./service/config.service";
import {EditorModule} from "primeng/editor";
import {InputSwitchModule} from "primeng/inputswitch";
import {ChipModule} from "primeng/chip";
import {ChipsModule} from "primeng/chips";
import {OverviewDocComponent} from './dashbord/overview-doc/overview-doc.component';
import {SkeletonModule} from "primeng/skeleton";
import {DataViewModule} from "primeng/dataview";
import {LinkGeneratorComponent} from './components/link-generator/link-generator.component';
import {ApiDocsComponent} from './api-docs/api-docs.component';
import {FileUploadModule} from "primeng/fileupload";
import {DateTextPipe} from "./pips/date-text.pipe";
import {NumberTextPipe} from "./pips/number-text.pipe";

export function initConfig(config: ConfigService) {
  return () => config.load();
}

const ROUTES: Routes = [
  // {
  //   path: '',
  //   redirectTo: "docs",
  //   pathMatch: 'full',
  // },

  {
    path: 'gotopage',
    children: [
      {path: '', component: LinkGeneratorComponent},
      {path: ':page_id', component: LinkGeneratorComponent},
      {path: ':page_id/:post_id', component: LinkGeneratorComponent}
    ]
  },
  {
    path: 'permalink',
    children: [
      {path: '', component: LinkGeneratorComponent},
      {path: ':page_id', component: LinkGeneratorComponent},
      {path: ':page_id/:post_id', component: LinkGeneratorComponent}
    ]
  },
  {
    path: '404',
    component: NotFoundPageComponent
  },
  {
    path: '',
    component: DocsComponent,
  },
  {
    path: 'apiDocs',
    component: ApiDocsComponent,
  },
  {
    path: 'newPage',
    component: NewPageComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'admin',
    component: AdminDocsComponent,
  },
  {
    path: 'dashboard',
    redirectTo: "dashboard/",
    pathMatch: 'full',
  },
  {
    path: "dashboard",
    component: TemplateComponent,
    children: [
      {path: '', component: AdminDocsComponent},
      {path: ':doc', component: AdminDocsComponent},
      {path: ':doc/:page', component: AdminDocsComponent},
      {path: 'overview', component: OverviewDocComponent},
      {path: 'overview/:doc', component: OverviewDocComponent},
      {path: 'overview/:doc/:page', component: OverviewDocComponent},

    ]
  },
  {
    path: ':doc',
    component: DocsComponent,
  },
  {
    path: ':doc/:page',
    component: DocsComponent,
  },
  {

    path: 'docs',
    children: [
      {path: '**', component: DocsComponent}
    ]
  },

  {
    path: '**',
    component: NotFoundPageComponent
  }

]

@NgModule({
    declarations: [
        AppComponent,
        DateTextPipe,
        HomeComponent,
        NotFoundPageComponent,
        NewPageComponent,
        SafeHtmlPipe,
        LoginComponent,
        TemplateComponent,
        DocsComponent,
        AdminDocsComponent,
        OverviewDocComponent,
        LinkGeneratorComponent,
        ApiDocsComponent,
        NumberTextPipe

    ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    NgxSuneditorModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(ROUTES),
    ButtonModule,
    InputTextModule,
    TabViewModule,
    DialogModule,
    ColorPickerModule,
    ConfirmDialogModule,
    ToastModule,
    ProgressBarModule,
    PasswordModule,
    SlideMenuModule,
    AutoCompleteModule,
    TreeModule,
    ContextMenuModule,
    InputTextareaModule,
    NgxPersianModule,
    EditorModule,
    InputSwitchModule,
    ChipModule,
    ChipsModule,
    SkeletonModule,
    DataViewModule,
    FileUploadModule
  ],
  providers: [
    RestBackendService,
    MessageService,
    ConfirmationService,
    GlobalService,
    JalaliDateCalculatorService,
    PersianNumberService,
    {
      provide: APP_INITIALIZER,
      useFactory: initConfig,
      deps: [ConfigService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
